export class EntTypesOfFertilizersFilter {
  page: number = 1;
  size: number = 30;
  name: string | null = null;
  categoryName: string | null = null;
}
